interface Scripts {
    name: string;
    src: string;
}  
export const ScriptStore: Scripts[] = [
    {name: 'signalViewer', src: 'assets/js/SignalViewerLib.js'},
];